/**
 * Created by matheusmorett on 13/08/18.
 */
import React, {Component} from 'react';

export default class NumberFormat extends Component {

    static defaultProps = {
      className: ""
    };

    render() {
        const { value, className } = this.props;

        let finalValue = '';

        if(typeof value === 'string') {
            finalValue = value.replace(".", ",").replace(/\B(?=(\d{3})+\b)/g, ".");
        } else if(typeof value === 'number') {
            finalValue = value.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+\b)/g, ".");
        }

        const curr = finalValue.split(",");

        // return (<p style={{padding: 0, margin: 0, display: 'inline'}}><span className={className}>{curr[0]}</span><span style={{fontSize: '11px'}}>{`,${curr[1]}`}</span></p>);

        return (<span><span className={className}>{curr[0]}</span><span>{`,${curr[1]}`}</span></span>);
    }

}